var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nationalityCode)?_c('v-avatar',{staticClass:"flag-border",attrs:{"size":_vm.size ? _vm.size : '40px'}},[_c('img',{attrs:{"src":this.assets()+'/flags/' + _vm.nationalityCode + '.png'}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }